import { render, staticRenderFns } from "./Parallax.vue?vue&type=template&id=6e8270a4&"
import script from "./Parallax.vue?vue&type=script&lang=js&"
export * from "./Parallax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e8270a4')) {
      api.createRecord('6e8270a4', component.options)
    } else {
      api.reload('6e8270a4', component.options)
    }
    module.hot.accept("./Parallax.vue?vue&type=template&id=6e8270a4&", function () {
      api.rerender('6e8270a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/Parallax.vue"
export default component.exports